import { ErrorBoundary } from "@repo/ui/components/ui/error-boundary";
import { SpinnerFullPage } from "@repo/ui/components/ui/spinner-full-page";
import { StatusMessage } from "@repo/ui/components/ui/status-message";
import { QueryClientProvider } from "@tanstack/react-query";
import { createRouter as createTanstackRouter } from "@tanstack/react-router";
import { createTRPCOptionsProxy } from "@trpc/tanstack-react-query";
import { queryClient } from "@/clients/queryClient";
import { trpcClient } from "@/clients/trpcClient";
import { env } from "@/env";
import { routeTree } from "@/routeTree.gen";
import { jsx as _jsx } from "react/jsx-runtime";
export const trpc = createTRPCOptionsProxy({
  client: trpcClient,
  queryClient
});
export function createRouter() {
  const router = createTanstackRouter({
    routeTree,
    context: {
      auth: undefined
    },
    basepath: env.PUBLIC_BASE_PATH,
    scrollRestoration: true,
    defaultPreload: "intent",
    defaultPendingComponent: () => /*#__PURE__*/_jsx(SpinnerFullPage, {
      message: "Laddar sida..."
    }),
    defaultErrorComponent: ({
      error
    }) => /*#__PURE__*/_jsx(ErrorBoundary, {
      fallback: /*#__PURE__*/_jsx("div", {
        className: "flex min-h-screen flex-col items-center justify-center p-4",
        children: /*#__PURE__*/_jsx("div", {
          className: "w-full max-w-md",
          children: /*#__PURE__*/_jsx(StatusMessage, {
            message: "Ett fel uppstod. V\xE4nligen f\xF6rs\xF6k igen senare.",
            variant: "error"
          })
        })
      }),
      children: error instanceof Error ? error.message : "Ett fel uppstod"
    }),
    Wrap: function WrapComponent({
      children
    }) {
      return /*#__PURE__*/_jsx(QueryClientProvider, {
        client: queryClient,
        children: /*#__PURE__*/_jsx(ErrorBoundary, {
          onReset: () => window.location.reload(),
          persistKey: "ffw:root-error-retries",
          children: children
        })
      });
    }
  });
  return router;
}